import { jsx as _jsx } from "react/jsx-runtime";
import { Children, createContext, isValidElement, useContext, useEffect, useMemo, useState } from 'react';
import { DESCRIPTION, TITLE } from '../../constants';
import { useId } from '../../hooks';
import { findChildRecursively } from '../../utils/findChildRecursively';
const Context = createContext({
    hasDescription: false,
    hasTitle: false,
    id: '',
    isOpen: false,
    onClose: () => { }
});
function Provider({ id: customId, isOpen = false, children, onClose = () => { }, ...rest }) {
    const id = useId(customId);
    const [hasTitle, setHasTitle] = useState(false);
    const [hasDescription, setHasDescription] = useState(false);
    const checkChild = useMemo(() => (child) => {
        if (isValidElement(child)) {
            const { displayName } = child.type;
            if (displayName === TITLE) {
                setHasTitle(true);
                return true;
            }
            if (displayName === DESCRIPTION) {
                setHasDescription(true);
                return true;
            }
            if (child.props.children) {
                Children.forEach(child.props.children, checkChild);
            }
            return true;
        }
        return false;
    }, []);
    useEffect(() => {
        setHasDescription(false);
        setHasTitle(false);
        findChildRecursively(children, checkChild);
    }, [children, checkChild]);
    const value = useMemo(() => ({
        hasDescription,
        hasTitle,
        id,
        isOpen,
        onClose
    }), [hasDescription, hasTitle, id, isOpen, onClose]);
    return (_jsx(Context.Provider, { value: value, ...rest, children: children }));
}
export const useDialogContext = () => {
    const context = useContext(Context);
    if (!context) {
        throw new Error('useDialogContext must be used within a DialogProvider');
    }
    return context;
};
export { Context, Provider };
//# sourceMappingURL=Context.js.map